// AUTO-GENERATED by scripts/generate-version.mjs from the root package.json — do not edit.
export const APP_VERSION = '2.0.3';
